// extracted by css-extract-rspack-plugin
export default {"button":"rJvbc","inner":"vYKAR","example":"mwkut","content":"Mmy8U","label":"fSWbC"};